import { create } from 'zustand';
import { PayrollPeriod, PayrollEntry } from '../types';

interface HrPayrollState {
  periods: PayrollPeriod[];
  activePeriod: PayrollPeriod | null;
  entries: PayrollEntry[];
  activeEntry: PayrollEntry | null;
  wizardStep: number;
  isLoading: boolean;

  setPeriods: (periods: PayrollPeriod[]) => void;
  setActivePeriod: (period: PayrollPeriod | null) => void;
  setEntries: (entries: PayrollEntry[]) => void;
  setActiveEntry: (entry: PayrollEntry | null) => void;
  setWizardStep: (step: number) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useHrPayrollStore = create<HrPayrollState>((set) => ({
  periods: [],
  activePeriod: null,
  entries: [],
  activeEntry: null,
  wizardStep: 0,
  isLoading: false,

  setPeriods: (periods) => set({ periods }),
  setActivePeriod: (activePeriod) => set({ activePeriod }),
  setEntries: (entries) => set({ entries }),
  setActiveEntry: (activeEntry) => set({ activeEntry }),
  setWizardStep: (wizardStep) => set({ wizardStep }),
  setLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ activePeriod: null, entries: [], activeEntry: null, wizardStep: 0 }),
}));
